
export class AchievementType {
    public static readonly BEAT_EASY_BOT = new AchievementType(
        "beat_easy_bot",
        "Defeat Easy Bot",
        "Win against the easy bot",
        false,
    );

    public static readonly BEAT_MEDIUM_BOT = new AchievementType(
        "beat_medium_bot",
        "Defeat Medium Bot",
        "Win against the medium bot",
        false,
    );

    public static readonly BEAT_HARD_BOT = new AchievementType(
        "beat_hard_bot",
        "Defeat Hard Bot",
        "Win against the hard bot",
        false,
    );

    public static readonly BEAT_PANDA_BOT = new AchievementType(
        "beat_panda_bot",
        "Defeat Panda Bot",
        "Win against the Panda bot",
        false,
    );

    public static readonly CLEAN_SWEEP = new AchievementType(
        "clean_sweep",
        "Clean Sweep",
        "Defeat all the bots!",
        false,
    );

    public static readonly REVIEW_UR = new AchievementType(
        "review_ur",
        "Review-Ur",
        "Complete a game review",
        true,
    );

    public static readonly NO_MURCY = new AchievementType(
        "no_murcy",
        "No Murcy",
        "Win without your opponent scoring a single piece",
        false,
    );

    public static readonly FULL_DEPLOY = new AchievementType(
        "full_deploy",
        "Full Deploy",
        "Get all your pieces on the board at once",
        true,
    );

    public static readonly CROWDED = new AchievementType(
        "crowded",
        "Crowded",
        "Fill your four home tiles with pieces",
        true,
    );

    public static readonly JACK_OF_UR_TRADES = new AchievementType(
        "jack_of_ur_trades",
        "Jack of Ur Trades",
        "Win a Finkel, Blitz, and Masters game",
        false,
    );

    public static readonly FINKEL_ONLINE = new AchievementType(
        "finkel_online",
        "Finkel Online",
        "Win a Finkel game online or against a friend",
        false,
    );

    public static readonly BLITZ_ONLINE = new AchievementType(
        "blitz_online",
        "Blitz Online",
        "Win a Blitz game online or against a friend",
        false,
    );

    public static readonly MASTERS_ONLINE = new AchievementType(
        "masters_online",
        "Masters Online",
        "Win a Masters game online or against a friend",
        false,
    );

    public static readonly RATING_1000 = new AchievementType(
        "rating_1000",
        "All-Rounder",
        "Reach 1000 rating in ranked Finkel, Blitz, and Masters",
        false,
    );

    public static readonly WIN_10 = new AchievementType(
        "win_10",
        "Competitur",
        "Win 10 games",
        false,
    );

    public static readonly WIN_100 = new AchievementType(
        "win_100",
        "Champion",
        "Win 100 games",
        false,
    );

    public static readonly MARKSMAN = new AchievementType(
        "marksman",
        "Marksman",
        "Achieve 80% accuracy online, against a friend, or against the Panda",
        false,
    );

    public static readonly SNIPUR = new AchievementType(
        "snipur",
        "Snipur",
        "Achieve 90% accuracy online, against a friend, or against the Panda",
        false,
    );

    public static readonly JUST_IN_TIME = new AchievementType(
        "just_in_time",
        "Just in Time",
        "Win when your opponent only has one piece left",
        false,
    );

    public static readonly STAND_UR_GROUND = new AchievementType(
        "stand_ur_ground",
        "Stand Ur Ground",
        "Hold the central rosette in Finkel when capturing off it is your only capture",
        true,
    );

    static values(): AchievementType[] {
        return [
            AchievementType.BEAT_EASY_BOT,
            AchievementType.BEAT_MEDIUM_BOT,
            AchievementType.BEAT_HARD_BOT,
            AchievementType.BEAT_PANDA_BOT,
            AchievementType.CLEAN_SWEEP,
            AchievementType.REVIEW_UR,
            AchievementType.NO_MURCY,
            AchievementType.FULL_DEPLOY,
            AchievementType.CROWDED,
            AchievementType.JACK_OF_UR_TRADES,
            AchievementType.FINKEL_ONLINE,
            AchievementType.BLITZ_ONLINE,
            AchievementType.MASTERS_ONLINE,
            AchievementType.RATING_1000,
            AchievementType.WIN_10,
            AchievementType.WIN_100,
            AchievementType.MARKSMAN,
            AchievementType.SNIPUR,
            AchievementType.JUST_IN_TIME,
            AchievementType.STAND_UR_GROUND,
        ];
    }

    // Instance fields
    private readonly id: string;
    private readonly displayName: string;
    private readonly desc: string;
    private readonly selfReported: boolean;

    private constructor(id: string, displayName: string, desc: string, selfReported: boolean) {
        this.id = id;
        this.displayName = displayName;
        this.desc = desc;
        this.selfReported = selfReported;
    }

    // Getters
    getID(): string {
        return this.id;
    }

    getDisplayName(): string {
        return this.displayName;
    }

    getDesc(): string {
        return this.desc;
    }

    isSelfReported(): boolean {
        return this.selfReported;
    }

    static getByID(id: string): AchievementType {
        const upperID = id.toUpperCase();
        for (const achievement of AchievementType.values()) {
            if (achievement.getID().toUpperCase() === upperID)
                return achievement;
        }
        throw new Error(`Unknown achievement type ${id}`);
    }

    static getByIDOrNull(id: string | null): AchievementType | null {
        if (id === null)
            return null;

        const upperID = id.toUpperCase();
        for (const achievement of AchievementType.values()) {
            if (achievement.getID().toUpperCase() === upperID)
                return achievement;
        }
        return null;
    }
}
